/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamPhotoIcon24Solid = forwardRef('TechCamPhotoIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.628 12.504a3.376 3.376 0 1 1 6.752 0 3.376 3.376 0 0 1-6.752 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 5a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-1l-.947-1.894A2 2 0 0 0 14.263 2H9.737a2 2 0 0 0-1.789 1.106L7 5H6Zm6.004 2.378a5.126 5.126 0 1 0 0 10.252 5.126 5.126 0 0 0 0-10.252Z" })));
});
